import type { Locale } from "./locales";
import { PILOT_CONTENT_REGISTRY } from "./content-registry";

/** Preserve the source destination until a counterpart is published. */
export function languageDestination(path: string, locale: Locale) {
  const counterpart = PILOT_CONTENT_REGISTRY.resolveCounterpart(path, locale);
  return counterpart.kind === "available" ? counterpart.href : path;
}
